import { createContext, useContext, useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { subscribe, getIsDown, forceUp } from "@/lib/systemStatusStore";

const SystemStatusContext = createContext(null);

const BACKOFF_STEPS = [1000, 2000, 4000, 8000, 15000];

export function SystemStatusProvider({ children }) {
  const [isDown, setIsDown] = useState(getIsDown());
  const timeoutRef = useRef(null);
  const attemptRef = useRef(0);

  useEffect(() => subscribe(setIsDown), []);

  const checkHealth = async () => {
    try {
      await api.get("/");
    } catch {
      // el store ya se actualiza vía el interceptor de respuesta
    }
  };

  const retryNow = () => {
    attemptRef.current = 0;
    checkHealth();
  };

  useEffect(() => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    if (!isDown) {
      attemptRef.current = 0;
      return;
    }
    const delay = BACKOFF_STEPS[Math.min(attemptRef.current, BACKOFF_STEPS.length - 1)];
    timeoutRef.current = setTimeout(async () => {
      attemptRef.current += 1;
      await checkHealth();
    }, delay);
    return () => clearTimeout(timeoutRef.current);
  }, [isDown]);

  return (
    <SystemStatusContext.Provider value={{ isDown, retryNow, forceUp }}>
      {children}
    </SystemStatusContext.Provider>
  );
}

export function useSystemStatus() {
  const ctx = useContext(SystemStatusContext);
  if (!ctx) throw new Error("useSystemStatus must be used inside SystemStatusProvider");
  return ctx;
}
